import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/pages/about/page.js");
